import type { LwCourseSummary } from '@ppwr/convex/learnworlds/types'

/**
 * PP-4829: product's order for the Learn tab, by LearnWorlds slug — titles get renamed
 * ("Regulate Your Emotions" is titled "Emotional Awareness"), slugs don't.
 * Unlisted courses follow, most enrolled first.
 */
export const COURSE_ORDER = [
  'understanding-outcome-bias', // Understanding Outcome Bias
  'breaking-with-perfectionism', // Breaking with Perfectionism
  'regulate-your-emotions', // Emotional Awareness
  'lm-strategic-mindset-shift-mobile' // Strategic Mindset Shifts
]

const normalize = (value: string) => value.trim().toLowerCase()

const hasCategory = (course: LwCourseSummary, category: string) =>
  course.categories.some((c) => normalize(c) === normalize(category))

/** The courses the Learn tab lists: those in `category` (all when empty), in `COURSE_ORDER`. */
export function selectLearnCourses(courses: LwCourseSummary[], category: string): LwCourseSummary[] {
  const filtered = category.trim() ? courses.filter((course) => hasCategory(course, category)) : courses
  const position = new Map(COURSE_ORDER.map((slug, index) => [slug, index]))
  const positionOf = (course: LwCourseSummary) => position.get(course.slug) ?? Number.POSITIVE_INFINITY
  return [...filtered].sort((a, b) => positionOf(a) - positionOf(b) || b.registeredUsers - a.registeredUsers)
}

/** Distinct categories across `courses` for the filter chips, alphabetical, first spelling wins. */
export function courseCategories(courses: LwCourseSummary[]): string[] {
  const byKey = new Map<string, string>()
  for (const category of courses.flatMap((course) => course.categories)) {
    const label = category.trim()
    if (label && !byKey.has(normalize(label))) byKey.set(normalize(label), label)
  }
  return [...byKey.values()].sort((a, b) => a.localeCompare(b))
}

/** The user's chip selection; `null` means "All". */
export function filterByCategory(courses: LwCourseSummary[], category: string | null): LwCourseSummary[] {
  return category ? courses.filter((course) => hasCategory(course, category)) : courses
}
